<div class="mfunsPlayer-video-color-model">
  <div class="mfunsPlayer-video-color-title">视频色彩调节</div>
  <div class="mfunsPlayer-video-color-close"></div>
  <div class="mfunsPlayer-video-color-item-wrap">
    <div class="mfunsPlayer-panel-row">
      <div class="row-title">饱和度</div>
      <div class="mfunsPlayer-video-saturate-slider mfunsPlayer-slider">
        {{ include './slider.art' }}
      </div>
      <div class="mfunsPlayer-video-saturate-value row-value">-</div>
    </div>

    <div class="mfunsPlayer-panel-row">
      <div class="row-title">亮度</div>
      <div class="mfunsPlayer-video-brightness-slider mfunsPlayer-slider">
        {{ include './slider.art' }}
      </div>
      <div class="mfunsPlayer-video-brightness-value row-value">-</div>
    </div>

    <div class="mfunsPlayer-panel-row">
      <div class="row-title">对比度</div>
      <div class="mfunsPlayer-video-contrast-slider mfunsPlayer-slider">
        {{ include './slider.art' }}
      </div>
      <div class="mfunsPlayer-video-contrast-value row-value">-</div>
    </div>
  </div>
  <div class="mfunsPlayer-video-color-reset">重&nbsp;置</div>
</div>
